<script setup lang="ts">
import NotificationItem from '../notification-item/NotificationItem.vue';
import type { NotificationType } from '../notification-item/NotificationBadge.vue';

export type Notification = {
  id: number | string;
  type: NotificationType;
  title: string;
  description: string;
  time: string;
  isRead: boolean;
  to?: string;
};

defineProps<{
  notifications: Notification[];
}>();
</script>

<template>
  <div class="flex flex-col bg-white rounded-lg shadow w-110 py-2">
    <template v-if="notifications.length > 0">
      <template v-for="(item, index) in notifications" :key="item.id">
        <NotificationItem
          :type="item.type"
          :title="item.title"
          :description="item.description"
          :time="item.time"
          :is-read="item.isRead"
          :to="item.to"
        />
        <hr v-if="index < notifications.length - 1" class="border-brown-100" />
      </template>
    </template>
    <div v-else class="flex flex-col items-center gap-2 px-4 py-4 text-center">
      <i class="mi-bell text-2xl text-brown-200" />
      <p class="font-roboto-slab font-bold text-sm text-brown-400">Žádná oznámení</p>
      <p class="font-montserrat text-xs text-brown-300">Momentálně nemáte žádná nová oznámení.</p>
    </div>
  </div>
</template>
